import { useRef } from 'react';

import { fastRandomId } from '../utils/crypto';

export const useId = (prefix?: string) => {
	const ref = useRef(fastRandomId(prefix));

	return ref.current;
};
